import type { AppletAccessDeniedProps } from '../../AppletGuard';
import CartographerAccessDeniedDialog from './CartographerAccessDeniedDialog';
import CartographerLayoutStateScaffold from './CartographerLayoutStateScaffold';

export default function CartographerLayoutAccessDenied({
  reason,
  message,
  loginUrl,
}: AppletAccessDeniedProps) {
  return (
    <CartographerLayoutStateScaffold>
      <CartographerAccessDeniedDialog
        reason={reason}
        message={message}
        loginUrl={loginUrl}
      />
    </CartographerLayoutStateScaffold>
  );
}
